<template>
    <div>
        <tab name="2">{{data && data.result && data.result[0].idNameVO.name}}(ID:{{id}})</tab>
        <div v-if="$utils.have('/performer/addMusic')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.musicEdit.show()">创建歌曲</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
                row-key="id"
                class="sortable-table"
            >
                <el-table-column prop="isTop" label="小站置顶">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isTop == 1" class="color-success">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="歌曲名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="tagVOS" label="风格" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.tagVOS" :key="index">
                            {{item.styleName}}{{item.tagName ? '-'+item.tagName : item.tagName}}
                            {{scope.row.tagVOS.length > index+1 ? '/' : ''}}
                        </span>   
                    </template>
                </el-table-column>
                <el-table-column prop="time" label="时长"></el-table-column>
                <el-table-column prop="clickNum" label="播放次数"></el-table-column>
                <el-table-column prop="createTime" label="上传时间" min-width="150"></el-table-column>
                <el-table-column prop="display" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.display == 1" type="success" size="mini">显示</el-tag>
                        <el-tag v-else type="info" size="mini">隐藏</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/performer/addMusic')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="scope.row.playUrl"
                            type="text"
                            size="small"
                            icon="el-icon-video-play"
                            @click="$player.play(scope.row)"
                            >播放</el-button
                        >
                        <el-button
                            v-if="$utils.have('/userCommon/topMusic')"
                            type="text"
                            size="small"
                            icon="el-icon-sort"
                            @click="setTop(scope.row)"
                            >{{scope.row.isTop == 1 ? '取消小站置顶' : '设为小站置顶'}}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <music-edit ref="musicEdit" :userId="id" @onUpdate="getDataList()"></music-edit>
    </div>
</template>

<script>
import Tab from './components/tab';
import MusicEdit from './components/music-edit';
import Sortable from "sortablejs";
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,MusicEdit
    },
    data() {
        return {
            data: null,
            dataList: [],
            params:{
                pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            listLoading: false, 
        };
    },
    mounted(){
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/performer/musicList",
                method: "POST",
                data: {
                    ...this.params,
                    id:this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result && result.result[0].musicListVOS || [];
                        if(this.$utils.have('/userCommon/sortMusic')){
                            this.drag();
                        }
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //编辑事件
        edit(data){
            this.$refs.musicEdit.show(data);
        },
        //置顶设置
        setTop(data){
            this.listLoading = true;
            this.$request({
                url: "/userCommon/topMusic",
                method: "POST",
                params: {
                    id:data.id,
                    isTop: data.isTop == 1 ? 0 : 1
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$message.success("操作成功");
                        this.getDataList();
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //拖拽排序
        drag(){
            this.$nextTick(() => {
                const el = document.querySelectorAll('.sortable-table > .el-table__body-wrapper > table > tbody')[0];
                    Sortable.create(el, {
                        disabled: false, // 拖拽不可用? false 启用
                        ghostClass: 'sortable-ghost', //拖拽样式
                        animation: 150, // 拖拽延时，效果更好看
                        onEnd: (e) => { // 拖拽结束时的触发
                            let arr = [...this.dataList]; // 获取表数据
                            arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                            this.$nextTick(function () {
                                const a1 = (this.dataList.map(a => a.id)).toString();
                                const a2 = (arr.map(a => a.id)).toString();
                                if(a1 != a2){
                                    this.dataList = arr;
                                    this.updateSort();
                                }
                            })
                        },
                    });
            })
        },
        //排序
        updateSort(){
            this.dataList.map((v,i) => {
                v.sort = (i + 1) + (this.params.pageNo - 1) * this.params.pageSize;
            })
            this.$request({
                url: '/userCommon/sortMusic',
                method: "post",
                data: this.dataList,
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("排序成功");
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    // this.bannerPoint[index].bannerList = [];
                });
        },
    },
};
</script>
